import { render, staticRenderFns } from "./SignUpDetail.vue?vue&type=template&id=ecf6f798&scoped=true&"
import script from "./SignUpDetail.vue?vue&type=script&lang=js&"
export * from "./SignUpDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf6f798",
  null
  
)

export default component.exports